import { omitBy, isNil, isEmpty } from "lodash";

const response = (data) => {
  const driver = data.driver;
  const street1 = driver.primaryAddress.street1;
  const street2 = driver.primaryAddress?.street2;
  const postcode = driver.primaryAddress.postcode;
  const city = driver.primaryAddress.city;
  const state = driver.primaryAddress.state;
  const country = driver.primaryAddress.country;

  return omitBy(
    {
      createdAt: driver.profile?.createdAt,
      updatedAt: driver.profile?.updatedAt,
      status: driver.status,
      _id: driver._id,
      code: driver.data.code,
      approvalStatus: driver.data?.approvalInfo?.approvalStatus,
      rejectedReason: driver.data?.approvalInfo?.rejectedReason,
      profileID: driver.profileID,
      fullName: driver.fullName,
      identityType: driver.identification.type,
      passportID: driver.identification.no,
      mobileNo: omitBy(
        {
          dialCode: driver.primaryPhone.countryCode,
          number: driver.primaryPhone.number,
        },
        isNil,
      ),
      mobileNumber: "+" + driver.primaryPhone.countryCode + " " + driver.primaryPhone.number,
      emailAddress: driver.primaryEmail,
      pendingEmail: driver.pendingEmail,
      street1: driver.primaryAddress.street1,
      street2: driver.primaryAddress.street2,
      postcode: driver.primaryAddress.postcode,
      city: driver.primaryAddress.city,
      state: driver.primaryAddress.state,
      country: driver.primaryAddress.country,
      fullAddress:
        street1 +
        ", " +
        (street2 || "") +
        (street2 ? "," : "") +
        city +
        ", " +
        state +
        ", " +
        postcode +
        ", " +
        country +
        ".",
      gender: driver.gender,
      vehicleType: driver.data.vehicleType,
      vehicleModel: driver.data.vehicleModel,
      vehiclePlateNumber: driver.data.vehiclePlateNumber,
      plateNumber: driver.data.vehiclePlateNumber,
      vehicleCategory: driver.data.vehicleCategory,
      doesRiderOwnVehicle: driver.data?.vehicleType ? "true" : "false",
      epfNo: driver.data.payrollDetails?.EPFNo,
      hrdfNo: driver.data.payrollDetails?.HRDFNo,
      socsoNo: driver.data.payrollDetails?.SOCSONo,
      accountNo: driver.data.payrollDetails?.accountNumber,
      accountType: driver.data.payrollDetails?.accountType,
      attachments: driver.data.attachments,
      nric_passport: driver.data.attachments.find((attachment) => {
        return attachment.type === "ID";
      })?.file,
      driving_license: driver.data.attachments.find((attachment) => {
        return attachment.type === "LICENSE";
      })?.file,
      road_tax: driver.data.attachments.find((attachment) => {
        return attachment.type === "ROAD_TAX";
      })?.file,
      photo_of_vehicle: driver.data.attachments.find((attachment) => {
        return attachment.type === "VEHICLE_PHOTO";
      })?.file,
      bankType: driver.data.payrollDetails?.bankType,
      parentOrgID: driver.orgID,
      companyName: driver.data.companyName,
      emergencyContactName: driver.data.emergencyContactName,
      emergencyContactNo: omitBy(
        {
          dialCode: driver.data?.emergencyContactNumber?.countryCode || null,
          number: driver.data?.emergencyContactNumber?.number || null,
        },
        isNil,
      ),
      relationship: driver.data.emergencyRelationship,
      incomeTax: driver.data.incomeTaxNo,
      onlineStatus: driver.data.onlineStatus,
      riderType: driver.data.riderType,
      tempDeleteInfo: driver.data.tempDeleteInfo,
      zakatNo: driver.data.zakatNo,
      // password:driver.
      // confirmPwd
    },
    (val) => (typeof val === "object" ? isEmpty(val) : isNil(val)),
  );
};

export default response;
